// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf, anyOf, maybe } from "@altostra/type-validations";
import { string, number, nullValidation, nullOrUndefined } from "@altostra/type-validations/lib/primitives";

const assetValidator = objectOf({
  id: string,
  created_at: number,
  name: string,
  size: number,
  territory_ids: arrayOf(string),
  app_group_id: string,
  ext: string,
  created_by: string,
  last_edited_by: string,
  url: string,
  type: string,
  src: anyOf(string, nullValidation),
  ratio: maybe(number),
  known_height: maybe(number),
  known_width: maybe(number),
});

export const isEngagementUploadAssetResult = objectOf({
  new_asset: anyOf(assetValidator, arrayOf(assetValidator)),
  // TODO (COMPI-2987)
  // Add type validation for error objects in 200 response
  // errors: {name: string, size: number, ext: string, error: string}[],
  errors: arrayOf(nullOrUndefined),
  index_html: string,
});
